import { render, staticRenderFns } from "./FormularioRegistrosInvalidos.vue?vue&type=template&id=cde4cbf0&"
import script from "./FormularioRegistrosInvalidos.vue?vue&type=script&lang=js&"
export * from "./FormularioRegistrosInvalidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports